(function(){
  var root = document.getElementById('pmp');
  if(!root) return;

  var handle = root.getAttribute('data-handle');
  var productId = root.getAttribute('data-product-id');

  function money(cents){
    try{
      return new Intl.NumberFormat('es-CL',{style:'currency',currency:root.getAttribute('data-currency') || 'CLP',maximumFractionDigits:0}).format(cents/100);
    }catch(e){ return '$'+Math.round(cents/100).toLocaleString('es-CL'); }
  }

  function splitTitle(title){
    var parts = (title || '').split(' - ');
    return { banda: parts.length > 1 ? parts[0] : '', disco: parts.length > 1 ? parts.slice(1).join(' - ') : (title || '') };
  }

  // ---- Badge "Nuevo" ----
  var newBadge = document.getElementById('pmp-badge-new');
  if(newBadge){
    var created = parseInt(root.getAttribute('data-created'), 10) * 1000;
    var days = parseFloat(root.getAttribute('data-new-days')) || 3;
    if(!isNaN(created) && (Date.now() - created) <= days * 86400000){
      newBadge.hidden = false;
    }
  }

  // ---- Galería ----
  var track = document.getElementById('pmp-track');
  var dots = Array.prototype.slice.call(root.querySelectorAll('.pmp-dot'));
  var prev = document.getElementById('pmp-prev');
  var next = document.getElementById('pmp-next');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pmp-thumb'));

  function goTo(i){
    if(!track) return;
    track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
  }
  function current(){
    return track ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }
  if(track){
    track.addEventListener('scroll', function(){
      var i = current();
      dots.forEach(function(d, idx){ d.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function(t, idx){ t.classList.toggle('is-active', idx === i); });
    }, { passive: true });
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ goTo(parseInt(t.getAttribute('data-i'), 10)); });
    });
    dots.forEach(function(d){
      d.addEventListener('click', function(){ goTo(parseInt(d.getAttribute('data-i'), 10)); });
    });
    if(prev) prev.addEventListener('click', function(){ goTo(Math.max(0, current() - 1)); });
    if(next) next.addEventListener('click', function(){ goTo(Math.min(dots.length - 1, current() + 1)); });
  }

  // ---- Zoom con el mouse sobre la foto (solo dispositivos con puntero fino) ----
  if(track && finePointer && !reduce){
    Array.prototype.forEach.call(track.querySelectorAll('.pmp-slide'), function(slide){
      var img = slide.querySelector('img');
      if(!img) return;
      slide.addEventListener('mouseenter', function(){ slide.classList.add('is-zoom'); });
      slide.addEventListener('mousemove', function(e){
        var r = slide.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
      });
      slide.addEventListener('mouseleave', function(){ slide.classList.remove('is-zoom'); });
    });
  }

  function currentImg(){
    if(!track) return null;
    var slides = track.querySelectorAll('.pmp-slide img');
    return slides[current()] || slides[0] || null;
  }

  // ---- Carrito (usa el carrito global PMCart) ----
  function addToCart(variantId, qty, done){
    if(window.PMCart){
      window.PMCart.addToCart(variantId, qty, done);
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    }).then(function(){ if(done) done(); });
  }
  function openCart(){
    if(window.PMCart) window.PMCart.open();
  }

  // ---- Variantes ----
  var product = null;
  var selected = [];
  var priceEl = document.getElementById('pmp-price');
  var stockEl = document.getElementById('pmp-stock');
  var optionsEl = document.getElementById('pmp-options');
  var addBtn = document.getElementById('pmp-add');
  var stickyAdd = document.getElementById('pmp-sticky-add');
  var stickyPrice = document.getElementById('pmp-sticky-price');
  var buyBtn = document.getElementById('pmp-consult');

  function findVariant(){
    if(!product) return null;
    return product.variants.find(function(v){
      return v.options.every(function(o, i){ return o === selected[i]; });
    });
  }

  function renderVariant(){
    var v = findVariant();
    if(!v){
      if(stockEl) stockEl.textContent = 'No disponible';
      if(addBtn) addBtn.disabled = true;
      return;
    }
    if(priceEl){
      var old = (v.compare_at_price && v.compare_at_price > v.price)
        ? '<span class="pmp-price-old">' + money(v.compare_at_price) + '</span>' : '';
      var newHtml = old + money(v.price);
      if(priceEl.innerHTML !== newHtml){
        priceEl.innerHTML = newHtml;
        if(!reduce){ priceEl.classList.remove('pmfx-bump'); void priceEl.offsetWidth; priceEl.classList.add('pmfx-bump'); }
      }
    }
    if(stickyPrice) stickyPrice.textContent = money(v.price);
    if(stockEl) stockEl.textContent = v.available ? 'Disponible' : 'Sin stock';
    if(addBtn) addBtn.disabled = !v.available;
    try{
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }catch(e){}
  }

  function valueAvailable(idx, value){
    return product.variants.some(function(v){
      if(!v.available || v.options[idx] !== value) return false;
      return v.options.every(function(o, i){ return i === idx || o === selected[i]; });
    });
  }

  function renderOptions(){
    if(!optionsEl) return;
    optionsEl.innerHTML = '';

    // Productos sin opción de talla (Default Title): talla única "Estándar"
    var hasRealOptions = product.options.some(function(o){
      var n = (o && typeof o === 'object') ? o.name : o;
      return n !== 'Title';
    });
    if(!hasRealOptions){
      var g = document.createElement('div');
      var l = document.createElement('span');
      l.className = 'pmp-opt-label';
      l.textContent = 'Talla';
      var w = document.createElement('div');
      w.className = 'pmp-opt-values';
      var chip = document.createElement('span');
      var anyAvailable = product.variants.some(function(v){ return v.available; });
      chip.className = 'pmp-opt is-selected is-static' + (anyAvailable ? '' : ' is-oos');
      chip.textContent = 'Estándar';
      w.appendChild(chip);
      g.appendChild(l);
      g.appendChild(w);
      optionsEl.appendChild(g);
      return;
    }

    product.options.forEach(function(opt, idx){
      var name = (opt && typeof opt === 'object') ? opt.name : opt;
      if(name === 'Title') return;
      var values = [];
      product.variants.forEach(function(v){
        if(values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
      });

      var group = document.createElement('div');
      var label = document.createElement('span');
      label.className = 'pmp-opt-label';
      label.textContent = name;
      var wrap = document.createElement('div');
      wrap.className = 'pmp-opt-values';

      values.forEach(function(val){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pmp-opt'
          + (val === selected[idx] ? ' is-selected' : '')
          + (valueAvailable(idx, val) ? '' : ' is-oos');
        b.textContent = val;
        b.addEventListener('click', function(){
          selected[idx] = val;
          renderOptions();
          renderVariant();
        });
        wrap.appendChild(b);
      });

      group.appendChild(label);
      group.appendChild(wrap);
      optionsEl.appendChild(group);
    });
  }

  fetch('/products/' + handle + '.js')
    .then(function(r){ return r.json(); })
    .then(function(p){
      product = p;
      var fromUrl = null;
      try{
        var vid = parseInt(new URL(window.location.href).searchParams.get('variant'), 10);
        if(vid) fromUrl = p.variants.find(function(v){ return v.id === vid; });
      }catch(e){}
      var start = fromUrl || p.variants.find(function(v){ return v.available; }) || p.variants[0];
      selected = start.options.slice();
      renderOptions();
      renderVariant();
    })
    .catch(function(){ /* si falla, queda el render del servidor */ });

  if(addBtn){
    addBtn.addEventListener('click', function(){
      var v = findVariant();
      if(!v) return;
      var original = addBtn.textContent;
      addBtn.disabled = true;
      addToCart(v.id, 1, function(){
        addBtn.textContent = 'Agregado ✓';
        addBtn.classList.add('is-added');
        var img = currentImg();
        if(window.PMFx && img) window.PMFx.fly(img, openCart);
        else openCart();
        setTimeout(function(){
          addBtn.textContent = original;
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
        }, 1800);
      });
    });
  }

  // ---- Añadir a consulta (WhatsApp con la variante elegida) ----
  var waNum = ((root && root.getAttribute('data-whatsapp')) || '').replace(/\D/g,'');
  function consult(){
    var v = findVariant();
    var label = v ? v.options.filter(function(o){ return o !== 'Default Title'; }).join(' / ') : '';
    var title = (root && root.getAttribute('data-title')) || document.title;
    var msg = 'Hola! Quiero consultar disponibilidad de: ' + title + (label ? ' (' + label + ')' : '') + '\n' + location.origin + location.pathname;
    var url = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(msg);
    window.open(url, '_blank', 'noopener');
  }

  var stickyBar = document.getElementById('pmp-sticky');

  if(!waNum){
    // Sin número de WhatsApp: se ocultan los botones de consulta
    if(buyBtn) buyBtn.hidden = true;
    if(stickyBar && stickyBar.parentNode) stickyBar.parentNode.removeChild(stickyBar);
  }else{
    if(buyBtn) buyBtn.addEventListener('click', consult);
    if(stickyAdd) stickyAdd.addEventListener('click', consult);

    // Barra pegajosa (móvil): aparece cuando los botones salen de pantalla hacia arriba
    var actions = document.getElementById('pmp-actions');
    if(stickyBar && actions && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        var e = entries[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-on', on);
        stickyBar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if(stickyAdd) stickyAdd.tabIndex = on ? 0 : -1;
      }).observe(actions);
    }
  }
})();